import BaseService from '@/ecm/common/BaseService.js';
import Utils from '@/ecm/common/Utils.js';

class LoggedUsersAdminService {
  baseUrl = 'logged-user-session-from-admin';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  delete = (id) => BaseService.delete({ url: `${this.baseUrl}/${id}` });
}

export default new LoggedUsersAdminService();
